import { useContext, useState } from 'react';

import { Button, Spinner } from 'react-bootstrap';
import { ButtonVariant } from 'react-bootstrap/esm/types';

import { Store } from '@website/Store';
import AuthenticationModal from './AuthenticationModal';

/**
 * Requires Auth
 *
 * Wrap any component (e.g. a page) in this to show a login screen, if the user is not logged in.
 *
 * @example
 * // Page that requires authorization
 * export default function MyPage() {
 *   return (<RequiresAuth>Page Content</RequiresAuth>);
 * }
 *
 */
export default function RequiresAuthButton({
  authModalTitle,
  loginButtonTitle,
  children,
  loginBtnVariant = 'primary',
  buttonSize,
}: RequiresAuthButtonProps) {
  const { state } = useContext(Store);
  const [showAuthModal, setShowAuthModal] = useState(false);

  // If still getting login state, show a spinner
  if (state.isAuthenticating) {
    <Button variant="primary" disabled>
      <Spinner
        as="span"
        animation="grow"
        size="sm"
        role="status"
        aria-hidden="true"
      />
      Loading...
    </Button>;
  }

  // If authenticated, just show children
  if (state.isAuthenticated) {
    return <>{children}</>;
  }

  // If unauthenticated, show login
  return (
    <>
      <Button
        size={buttonSize}
        variant={loginBtnVariant}
        onClick={() => setShowAuthModal(true)}
      >
        {loginButtonTitle}
      </Button>
      {showAuthModal && (
        <AuthenticationModal
          showModal={showAuthModal}
          onSuccess={() => {
            setShowAuthModal(false);
          }}
          onHide={() => setShowAuthModal(false)}
          authModalTitle={authModalTitle}
        />
      )}
    </>
  );
}

export interface RequiresAuthButtonProps {
  children: any;
  loginButtonTitle;
  authModalTitle?: string;
  loginBtnVariant?: ButtonVariant;
  buttonSize?: 'sm' | 'lg';
}
